customElements.get("quick-add-modal") ||
  customElements.define(
    "quick-add-modal",
    class extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        window.addEventListener("keyup", (e) => {
          if (e.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      hide(preventFocus = false) {
        this.classList.remove("images-ready");
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";
        if (preventFocus) this.openedBy = null;
        super.hide();
        setTimeout(() => this.remove(), 500);
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            this.productElement = doc.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.outerHTML, opener);
            window.Shopify?.PaymentButton?.init();
            window.ProductModel?.loadShopifyXR?.();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
            this.initQuickAddProductMedia();
          });
      }

      initQuickAddProductMedia() {
        window.productMediaSlidersInitInContainer?.(this, true);
        const productSection = window.getQuickAddProductSection
          ? window.getQuickAddProductSection(this)
          : this.modalContent.querySelector(
              'section[id^="MainProduct-"], section.main-product, .main-product'
            );
        if (productSection && window.initProductMediaGallery) {
          window.initProductMediaGallery(productSection);
        }
        this.classList.add("images-ready");
      }

      setInnerHTML(container, html, opener) {
        container.innerHTML = html;
        container.querySelectorAll("script").forEach((oldScript) => {
          const script = document.createElement("script");
          Array.from(oldScript.attributes).forEach((attr) => {
            script.setAttribute(attr.name, attr.value);
          });
          script.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(script, oldScript);
        });

        const title = document.createElement("h2");
        title.setAttribute("class", "quick-add-modal__title h3");
        title.innerText = theme.quickAddTitle;
        container.querySelector(".product")?.prepend(title);

        const detailsLink = document.createElement("a");
        detailsLink.innerHTML = `<span>${theme.quickviewMore}</span>`;
        detailsLink.setAttribute("href", opener.getAttribute("data-product-url"));
        detailsLink.setAttribute("class", "product__full-details button button--simple_secondary");
        container.querySelector(".product-form__buttons")?.appendChild(detailsLink);
      }

      removeDOMElements() {
        this.productElement.querySelectorAll(".product-popup").forEach((el) => el.remove());
        this.productElement.querySelectorAll(".about").forEach((el) => el.remove());
        [
          ".share-buttons",
          ".product__sku",
          ".breadcrumb",
          ".product-tags",
          ".pickup-availability",
          ".pickup-availability__overlay",
          "product-modal",
          ".product__description",
          ".product__inventory",
        ].forEach((selector) => {
          this.productElement.querySelector(selector)?.remove();
        });
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
          sectionId,
          "quickadd-" + sectionId
        );
        this.productElement.querySelectorAll("variant-selects, variant-radios").forEach((el) => {
          el.dataset.originalSection = sectionId;
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector("variant-radios, variant-selects");
        if (variantPicker) variantPicker.setAttribute("data-update-url", "false");
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        if (!product?.classList.contains("product--columns")) return;

        const images = product.querySelectorAll(".product__media img");
        if (!images.length) return;

        let sizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        if (product.classList.contains("product--medium")) {
          sizes = sizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          sizes = sizes.replace("715px", "495px");
        }
        images.forEach((img) => img.setAttribute("sizes", sizes));
      }
    }
  );
